var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkLifeBalance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Work-Life Balance"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5502 19.6401H9.4502L11.2102 13.4301L12.0002 10.6201L12.7902 13.4301L14.5502 19.6401Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.51 12.9302H12.79",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.2102 12.9302H2.49023",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.39039 6.37012H4.02039C3.67797 6.37012 3.40039 6.6477 3.40039 6.99012V9.77012C3.40039 10.1125 3.67797 10.3901 4.02039 10.3901H8.39039C8.73281 10.3901 9.01039 10.1125 9.01039 9.77012V6.99012C9.01039 6.6477 8.73281 6.37012 8.39039 6.37012Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19.5995 6.16016C20.0995 6.66016 20.0995 7.47016 19.5995 7.97016L17.5595 10.0102L15.5195 7.97016C15.0195 7.47016 15.0195 6.66016 15.5195 6.16016C16.0195 5.66016 16.8295 5.66016 17.3295 6.16016L17.5595 6.39016L17.7895 6.16016C18.2895 5.66016 19.0995 5.66016 19.5995 6.16016Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M5.58008 8.37988H6.82008",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M5.2998 6.3699V5.1499H7.1098V6.3699",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkLifeBalance);
export default __webpack_public_path__ + "static/media/Work-Life Balance.107788c4e9039e7285bbd775caf97c6f.svg";
export { ForwardRef as ReactComponent };